module.exports = __webpack_public_path__ + "img/step-2.6c4062f3.png";